import React from 'react'
import * as S from './styles'

const Field = ({ onChange, value, ...restProps }) => {
  return <S.Input onChange={onChange} value={value} {...restProps} />
}

export { Field }
